
import { instantiate } from './OhsPlayerReferenceClientApp-ohs-player-reference-app.uninstantiated.mjs';


const exports = (await instantiate({
})).exports;

export const {
memory,
_initialize
} = exports


